import {
  COLOMBIAHOSTING_HOMEPAGE,
  GODADDY_HOMEPAGE, LOCAWEB_HOMEPAGE, NEUBOX_HOMEPAGE, REGISTROBR_HOMEPAGE, SUPPORT_ARTICLE_CHANGE_DNS_COLOMBIAHOSTING, SUPPORT_ARTICLE_CHANGE_DNS_GODADDY, SUPPORT_ARTICLE_CHANGE_DNS_LOCAWEB, SUPPORT_ARTICLE_CHANGE_DNS_NEUBOX, SUPPORT_ARTICLE_CHANGE_DNS_OTHERS, SUPPORT_ARTICLE_CHANGE_DNS_REGISTROBR, SUPPORT_ARTICLE_CHANGE_DNS_UOLHOST, SUPPORT_ARTICLE_CHANGE_DNS_WEBEMPRESA, UOLHOST_HOMEPAGE,
  WEBEMPRESA_HOMEPAGE,
} from '@/config/urls/supportUrls';
import { PROVIDERS } from '@/pages/Domains/ChangeDomainHandler/components/ExternalDomain/ExternalDomain.types';
import { Link } from 'gatorcomponents';
import React from 'react';

export default {
  steps: {
    inputDomain: {
      title: '¿Cuál es la dirección de su sitio web?',
      description: 'Defina el nuevo dominio para su sitio web',
      continueCta: 'Continuar',
      backCta: 'Volver',
      alertDescription: domain => (
        <>
          {'El nuevo dominio reemplazará el actual '}
          <Link text={domain} href={`http://${domain}`} target="_blank" />
        </>
      ),
      toggledContent: 'El sitio web no estará disponible hasta que se concluya todo el proceso.',
      toggleCta: '¿Cómo funciona?',
      temporaryToggledContent: (
        <>
          <span>Por el momento, la dirección de su sitio web es temporal</span>

          <span>
            {'El dominio temporal sirve como una dirección provisional para alojar y acceder a su sitio web en la '}
            <strong>fase de prueba o desarrollo</strong>
            {', antes de vincularlo a su '}
            <strong>propio dominio.</strong>
          </span>

          <span>El sitio no estará disponible hasta que se complete todo el proceso.</span>
        </>
      ),
      mySiteLabel: 'meusite.com',
      domainEqualOriginalDomain: 'El dominio ingresado es el mismo que ya se utiliza en este sitio. Complete otro dominio para continuar con el cambio.',
      domainMessageErrorBr: '¡Dominio inválido! No puede contener caracteres especiales (excepto guiones), comenzar y terminar con guiones, contener solo números o tener más de 26 caracteres.',
      domainMessageError: '¡Dominio inválido! No puede contener caracteres especiales (excepto guiones), comenzar y terminar con guiones, contener solo números o tener más de 63 caracteres.',
      backendErrors: {
        genericError: {
          title: 'No fue posible continuar con el dominio ingresado',
          info: 'Por favor complete el campo siguiendo los estándares de un dominio (ejemplo: misitio.com) o complete el campo con otro dominio.',
        },
        HOSTING_NOT_AVAILABLE: {
          title: 'No encontramos un hospedaje o servidor para su dominio',
          info: 'Verifique las informaciones y vuelva a intentarlo',
        },
        NOT_UPDATE_DOMAIN_IN_CPANEL_HOSTING: {
          title: 'Este dominio ya está vinculado a su hosting',
          info: '',
        },
        SAME_DOMAIN: {
          title: 'Dominio ya registrado',
          info: 'El dominio que intentas registrar ya está vinculado a tu cuenta.',
        },
      },
    },
    domainNotRegistered: {
      title: 'El dominio indicado está disponible para  compra',
      description: 'Será redirigido para comprarlo y podrá regresar para completar la configuración',
      backButton: 'Volver',
      continueButton: 'Comprar dominio',
    },
    success: {
      title: '¡Listo! Su dominio se está configurando con éxito',
      description: 'Espere hasta 2 horas para que el sitio se active con el nuevo dominio',
      helpLabel: (
        <>
          {'Si tiene alguna duda, '}
          <Link
            text="acceda al material sobre el periodo de configuración."
            target="_blank"
            href="https://soporte.hostgator.mx/hc/es-419/articles/28440245535763--Qu%C3%A9-es-la-propagaci%C3%B3n"
          />
        </>
      ),
      backToSitesButtonLabel: 'Volver a Sitios web',
    },
    domainNotRegisteredSuccess: {
      title: '¡Gran elección! Está comprando un nuevo dominio',
      description: 'Una vez completado, vuelva al portal para finalizar la configuración de DNS',
      helpLabel: (
        <>
          {'Si tiene alguna duda, '}
          <Link
            text="acceda al material sobre como configurar DNS "
            target="_blank"
            href="https://soporte.hostgator.mx/hc/es-419/articles/28439712129043-C%C3%B3mo-configurar-el-dominio-cambiar-DNS"
          />
        </>
      ),
      backToSitesButtonLabel: 'Volver para Sitios web',
    },
    externalSuccess: {
      title: '¡Listo! Todo está bien si ya ha completado la configuración.',
      description: 'Espere hasta 2 horas para que el sitio se active con el nuevo dominio',
      helpLabel: 'En caso de que no haya realizado la configuración en el proveedor de dominio, regrese al paso anterior',
      backToLastPageButtonLabel: lastPage => `Ir a ${lastPage}`,
      goBackLabel: 'Volver',
    },
    externalDomain: {
      titleLabel: 'El dominio indicado fue registrado con otra empresa',
      descriptionLabel: 'Para conectarlo al sitio web apunte el DNS a nuestro hosting',
      whereFrom: '¿Dónde se registró su dominio?',

      providers: {
        [PROVIDERS.REGISTROBR]: {
          label: 'Registro.br',
          link: REGISTROBR_HOMEPAGE,
        },
        [PROVIDERS.GODADDY]: {
          label: 'GoDaddy',
          link: GODADDY_HOMEPAGE,
        },
        [PROVIDERS.LOCAWEB]: {
          label: 'Locaweb',
          link: LOCAWEB_HOMEPAGE,
        },
        [PROVIDERS.UOL_HOST]: {
          label: 'UOL Host',
          link: UOLHOST_HOMEPAGE,
        },
        [PROVIDERS.OTHERS]: {
          label: 'Outro',
          link: '',
        },
        [PROVIDERS.COLOMBIA_HOSTING]: {
          label: 'Colombia Hosting',
          link: COLOMBIAHOSTING_HOMEPAGE,
        },
        [PROVIDERS.WEB_EMPRESA]: {
          label: 'Web Empresa',
          link: WEBEMPRESA_HOMEPAGE,
        },
        [PROVIDERS.NEUBOX]: {
          label: 'Neubox',
          link: NEUBOX_HOMEPAGE,
        },
      },
      dnsContentTitle: 'Reemplace los registros DNS de su proveedor actual por los de HostGator',
      currentDns: currentProvider => `DNS actual en ${currentProvider}`,
      hostgatorDns: 'DNS en HostGator',
      serverLabel: serverIndex => `Servidor ${serverIndex}: `,
      goBack: 'Volver',
      continue: 'Continuar',
      configureDomain: 'Configurar dominio',
      copySuccess: '¡Texto copiado con éxito!',
      helpCenterLabel: url => (
        <>
          {'Si tiene alguna duda, '}
          <Link text="acceda a nuestra Central de Ayuda." href={url} target="_blank" />
        </>
      ),
      helpCenterUrls: {
        [PROVIDERS.REGISTROBR]: SUPPORT_ARTICLE_CHANGE_DNS_REGISTROBR,
        [PROVIDERS.GODADDY]: SUPPORT_ARTICLE_CHANGE_DNS_GODADDY,
        [PROVIDERS.LOCAWEB]: SUPPORT_ARTICLE_CHANGE_DNS_LOCAWEB,
        [PROVIDERS.UOL_HOST]: SUPPORT_ARTICLE_CHANGE_DNS_UOLHOST,
        [PROVIDERS.OTHERS]: SUPPORT_ARTICLE_CHANGE_DNS_OTHERS,
        [PROVIDERS.COLOMBIA_HOSTING]: SUPPORT_ARTICLE_CHANGE_DNS_COLOMBIAHOSTING,
        [PROVIDERS.WEB_EMPRESA]: SUPPORT_ARTICLE_CHANGE_DNS_WEBEMPRESA,
        [PROVIDERS.NEUBOX]: SUPPORT_ARTICLE_CHANGE_DNS_NEUBOX,
      },
    },
  },
  reinforcementModal: {
    title: '¿Estás seguro de que quieres cambiar el dominio?',
    description: {
      0: ({ originalDomainName, newDomain }) => (
        <>
          {'Al continuar, el sitio web, el correo electrónico y otras conexiones que puedan existir con el dominio '}
          <strong>{`"${originalDomainName}"`}</strong>
          {' cambiarán al nuevo dominio '}
          <strong>{`"${newDomain}"`}</strong>
          .  Es importante tener en cuenta que puedes perder tus casillas de correo electrónico en este proceso, además de que tu sitio web ya no funcione, dependiendo de la forma en que fue construido, requiriendo acciones manuales de tu parte para corregirlo.
        </>
      ),
      1: (
        <>
          Te recomendamos que antes de continuar, hagas una copia de seguridad de tu hosting, siguiendo nuestras instrucciones disponibles en el material del
          <Link
            href="https://soporte.hostgator.mx/hc/es-419/articles/28441509499411-C%C3%B3mo-hacer-un-Backup-copia-de-seguridad-completa"
            text="Central de Ayuda."
          />
        </>
      ),
    },
    continue: 'Estoy consciente. Continuar',
    cancel: 'Cancelar',
  },
  breadCrumbs: {
    inputDomain: 'Cambiar dominio',
    externalDomain: 'Dominio externo',
    success: 'Configuração',
    domainNotRegistered: 'Comprar Dominio',
  },
  blockTemporaryDomainEmailModal: {
    title: 'Configure un dominio propio',
    description: domain => (
      <>
        <span>
          Para administrar una cuenta de correo electrónico, es necesario utilizar su propio dominio. Actualmente está utilizando el dominio temporal
          {' '}
          <b>
            {domain}
            .
          </b>
          {' '}
          <p>Acceda a nuestro flujo de cambio de dominio para completar esta configuración.</p>
        </span>
        <p>
          Una vez que haya configurado su propio dominio, vuelva a empezar a crear su buzón de correo electrónico
        </p>
      </>
    ),
    continueButton: 'Cambiar dominio',
    backButton: 'Volver',
  },
  lastPages: {
    'sitios-web': 'Sitios web',
    productos: 'Hospedajes y Servidores',
  },
  tempDomainModalBeforeEmail: {
    title: 'Configure un dominio propio',
    content: optionLabel => (
      <>
        {'Observamos que uno o más de sus sitios en ese alojamiento todavía están usando un dominio temporal. Para acceder a la opción '}
        <strong>{`"${optionLabel}"`}</strong>
        , todos los sitios web deben tener su propio dominio definido. Por favor, vaya al flujo de cambio de dominio para realizar el cambio.
      </>
    ),
    changeDomainLabel: 'Cambiar dominio',
    contentAfterList: 'Una vez que todos los sitios de este alojamiento esten configurados con su propio dominio, vuelva a acceder a la opción deseada',
    backLabel: 'Volver',
  },
  changeDomainBlockModal: {
    title: 'Cambio de dominio para el creador de sitios web',
    description: 'Actualmente no es posible cambiar el dominio de un sitio web utilizando Website Builder. Si tiene alguna pregunta, comuníquese con nuestro soporte.',
    buttonLabel: 'Cancelar',
  },
};
